import { Component, OnInit } from '@angular/core';
import { AreaFocus } from '../../../models';
import { Router, NavigationEnd } from '@angular/router';
import { PworkflowComponent } from '../index';
import { ServiceInterface } from 'services/service.interface';
import { GoogleAnalyticsEventsService } from 'services/google.analytics.events.service';
import { IMajor, IBucket, SBucket } from 'app/interfaces';

declare var $: any;
@Component({
  selector: 'secondary',
  templateUrl: 'secondary.component.html'
})

export class SecondaryComponent implements OnInit {
  //states: any[] = stateConstant;
  formClass: string = "";
  errormsg: any[] = new Array();
  errdisplay: boolean = false;
  majors: IMajor[];
  bucketlist: IBucket[];
  secondaryBucketList: SBucket[];
  secBucket: any;
  trackingName = "Secondary";
  educationSelected: boolean = false;
  textOptional: string = "";

  constructor(private _services: ServiceInterface,public _parent: PworkflowComponent, private router: Router, public googleAnalyticsEventsService: GoogleAnalyticsEventsService) { }

  async ngOnInit() {
    if(this._parent.campaignName){
      this.trackingName = this._parent.campaignName+" - Secondary";
    }
    if(this._parent.model.bucket_id == '10') {
      this.educationSelected = true;
    }
    this.secondaryBucketList = await this._services.getList('/secondarybucketlist/' + this._parent.model.bucket_id);

    if(this._parent.model.bucket_id == '10') {
      this.educationSelected = true;

      this.secondaryBucketList.map(x => {
        if(x.secBucketId == 114 || x.secBucketId == 111 || x.secBucketId == 142 || x.secBucketId == 122) {
          x.order = 2;
        } else if(x.secBucketId == 131 || x.secBucketId == 151 || x.secBucketId == 149 || x.secBucketId == 126 || x.secBucketId == 36 || x.secBucketId == 35 || x.secBucketId == 118 || x.secBucketId == 123 || x.secBucketId == 140 || x.secBucketId == 81 || x.secBucketId == 145) {
          x.order = 1;
        } else if(x.secBucketId == 32 || x.secBucketId == 34 || x.secBucketId == 128 || x.secBucketId == 33 || x.secBucketId == 134) {
          x.order = 3;
        } else {
          x.order = 4;
        }
      })

      this.secondaryBucketList.sort(function(a,b) {
        if(a.order > b.order) {
          return 1;
        } else {
          return -1;
        }
      })

      this.secondaryBucketList.sort(function(a,b) {
        if(a.order == b.order) {
          if(a.secBucketTitle < b.secBucketTitle) {
            return -1;
          }
          if(a.secBucketTitle > b.secBucketTitle) {
            return 1;
          }
        }
      })
    }

    if(this._parent.model.bucket_id.includes("19")){
      this.textOptional = "";
    }else{
      this.textOptional = "(Optional)";
    }
    
    var elmnt = document.getElementById("top");
    elmnt.scrollIntoView();
  }

  getCheckboxValue(id){
    if(this._parent.model.secondary_bucket.length > 0){
        let index = this._parent.model.secondary_bucket.findIndex(x => x.id == id);
        if(index > -1){
            return true;
        }else{
            return false;
        }
    }else{
        return false;
    }
  }

  checkSecondaryBucket(event,id,name){
      if(event.target.checked){
        $(".secondary_bucket").removeClass('ng-checkinvalid');  
        let csitem = new AreaFocus();
        if (this._parent.model.secondary_bucket.findIndex(x => x.id == id) < 0) {
            csitem.name = name;
            csitem.id = id;
            this._parent.model.secondary_bucket.push(csitem);
        }
      }else{
        for (var index = 0; index < this._parent.model.secondary_bucket.length; index++) {
            if (this._parent.model.secondary_bucket[index]["id"] == id) {
              this._parent.model.secondary_bucket.splice(index, 1);
            }
          }
      }
  }

  clickSubmit(valid) {
    this.errormsg = [];
    if(this._parent.model.bucket_id.includes("19") && this._parent.model.secondary_bucket.length < 1){
      $(".secondary_bucket").addClass('ng-checkinvalid');
      valid = false;
    }
    if (valid) {
      this.secondarysubmit();
    } else {
      if(this._parent.model.secondary_bucket.length < 1){
        this.errdisplay = true;
        this.errormsg.push("Please select Area of focus.");
        valid = false;
      }
      this.formClass = "validate";
    }
  }

  secondarysubmit() {
    //this.googleAnalyticsEventsService.emitEvent(this.trackingName, this.trackingName, this.trackingName, 3);
    if (this._parent.model.secondary_bucket.length > 0) {
      this._parent.model.secondary_bucket_ids = this._parent.model.secondary_bucket.map(a => a.id).join(',');
      this._parent.index++;
    } else {
      this._parent.index++;
    }
  }

  prevAction() {
    this._parent.index--;
    //this.router.navigate(['/']);
  }
}


// WEBPACK FOOTER //
// ./src/app/components/pworkflow/secondary/secondary.component.ts